/* Schwebende Fremd-Knoepfe ausblenden, solange ein Overlay offen ist.
 *
 * DAS PROBLEM, gemessen am 21.09.2026 auf naturbohne.de:
 * Der Usercentrics-Knopf (aside#usercentrics-cmp-ui, 64 px, z-index
 * 2147483640, bottom 40 left 40) deckt den Chat-Knopf von Shopify Inbox
 * (shopify-chat, z-index 2147483000, bottom 20 left 20) teilweise zu. Auf dem
 * Telefon liegen beide zusaetzlich ueber dem geoeffneten Menue und verdecken
 * dort die Sprach- und Waehrungswahl.
 *
 * WAS DIESE DATEI TUT: sie blendet den Usercentrics-Knopf aus, solange eine
 * Schublade oder ein Overlay des Themes offen ist. Sie verschiebt nichts und
 * aendert keine Farbe. Dass die beiden Knoepfe SICH UNTEREINANDER decken, ist
 * eine Positionseinstellung in den jeweiligen Apps und gehoert dorthin, nicht
 * in ein Skript, das bei jedem App-Update brechen kann.
 *
 * WARUM HIER EIN SKRIPT NOETIG IST: der Knopf liegt in einem Shadow Root.
 * Seiten-CSS kommt dort nicht hinein. Den Host ganz auszublenden waere falsch,
 * weil im selben Shadow Root das Zustimmungs-Banner sitzt; ein Banner, das
 * beim Oeffnen des Menues verschwindet, waere ein Datenschutz-Fehler und kein
 * Layout-Fix. Deshalb liegt die Regel IM Shadow Root und trifft nur den Knopf.
 *
 * Shopify Inbox braucht kein Skript, dessen Host ist selbst fixiert und wird
 * aus apps.css ausgeblendet. Dieselbe Bedingung, dort noch einmal.
 *
 * WORAN DER ZUSTAND ERKANNT WIRD, und warum nicht an der Body-Klasse:
 * das Theme setzt `has-modal-opening` und tauscht es gegen `has-modal-open`,
 * sobald der Uebergang durch ist. Am 21.09.2026 gemessen: nach einem echten
 * Klick auf das Menue blieb `has-modal-opening` stehen und wurde nie zu
 * `has-modal-open`. Eine Regel darauf haette die Knoepfe dauerhaft
 * verschwinden lassen. Das `open`-Attribut der Schubladen dagegen wird beim
 * Schliessen zuverlaessig entfernt, ebenfalls gemessen.
 */
(function () {
  var HOST_ID = 'usercentrics-cmp-ui';
  var KLASSE = 'nb-overlay-offen';
  var MARKE = 'nb-schwebe-knoepfe';
  var OFFEN =
    'menu-drawer[open], cart-drawer[open], search-drawer[open], newsletter-modal[open], modal-element[open]';

  function regelSetzen(host) {
    if (host.shadowRoot.querySelector('style[data-' + MARKE + ']')) return;
    var stil = document.createElement('style');
    stil.setAttribute('data-' + MARKE, '');
    /* :host() statt :host-context(): letzteres kennt nicht jeder Browser, und
       der Zustand laesst sich genauso gut am Host selbst markieren. */
    stil.textContent = ':host(.' + KLASSE + ') .privacyButton{display:none !important}';
    host.shadowRoot.appendChild(stil);
  }

  function zustand(host) {
    host.classList.toggle(KLASSE, !!document.querySelector(OFFEN));
  }

  function start(host) {
    regelSetzen(host);
    zustand(host);
    new MutationObserver(function () {
      zustand(host);
    }).observe(document.documentElement, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['open'],
    });
  }

  function suchen() {
    var host = document.getElementById(HOST_ID);
    if (!host || !host.shadowRoot) return false;
    start(host);
    return true;
  }

  if (suchen()) return;

  /* Das CMP laedt asynchron. Hier wird bewusst gepollt und nicht beobachtet:
     das Anhaengen eines Shadow Roots ist KEINE DOM-Mutation. Der erste Lauf
     am 21.09.2026 benutzte einen MutationObserver, sah den Host in dem Moment
     noch ohne Shadow Root und wurde danach nie wieder geweckt. Gemessen:
     Regel nie gesetzt, Knopf blieb sichtbar.
     Alle 250 ms, hoechstens 30 Sekunden. Danach ist das CMP auf dieser Seite
     nicht vorhanden und es gibt nichts zu tun. */
  var versuche = 0;
  var takt = setInterval(function () {
    versuche += 1;
    if (suchen() || versuche > 120) clearInterval(takt);
  }, 250);
})();
